module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/course/labs/awsop/awsop-lab7/awsop-lab7.component.css
// module id = ./src/app/course/labs/awsop/awsop-lab7/awsop-lab7.component.css
// module chunks = main